import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  CustomInput,
  FormFeedback,
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loader from "commonComponents/Loader";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanyList } from "components/companyList/redux/dispatcher";
import {
  fetchMachineListByCompanyId,
  fetchMachineListForBulkUpload,
  generateReport,
} from "./redux/dispatcher";
import toast from "react-hot-toast";
import { fetchOilList } from "components/oilList/redux/dispatcher";
import useClickOutside from "commonComponents/useClickOutSide";

const Report = () => {
  const dispatch = useDispatch();
  const companyListData =
    useSelector((state) => state.companyListReducer?.data?.data) || [];
  const machineListData =
    useSelector((state) => state.reportReducer?.machineByCompanyIdforreport) ||
    [];
  const oilListData =
    useSelector(
      (state) => state.oilListReducer?.data?.oilDataWithSerialNumber
    ) || [];
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [machineList, setMachineList] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState([]);
  const [machineSearch, setMachineSearch] = useState("");
  const [filteredMachineList, setFilteredMachineList] = useState(machineList);
  const [reportTypes, setReportTypes] = useState([
    {
      id: 1,
      name: "Coolant Monitoring Report",
    },
    {
      id: 2,
      name: "Hydraulic Oil Report",
    },
    {
      id: 3,
      name: "Neat Oil Report",
    },
  ]);
  const [selectedReportType, setSelectedReportType] = useState("");
  const [today] = useState(new Date());
  const [dateRange, setDateRange] = useState([
    new Date(today.setDate(today.getDate() - 7)),
    new Date(),
  ]);
  const [startDate, endDate] = dateRange;
  const [isLoader, setIsLoader] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [coolantOil, setCoolantOil] = useState("");
  const [isAllMachineSelect, setIsAllMachineSelect] = useState(false);
  const dropdownRef = useRef(null);
  const anotherRef = useRef(null);

  function convertDateString(dateString) {
    let date = new Date(dateString);
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, "0");
    let day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };
  useEffect(() => {
    dispatch(fetchCompanyList());
  }, [dispatch]);

  useEffect(() => {
    setCompanyList(companyListData);
  }, [companyListData]);

  useEffect(() => {
    if (selectedCompany !== null && selectedCompany !== "" && selectedReportType !== null && selectedReportType !== "") {
      let oilType = "";
      if (selectedReportType == 1) oilType = "coolant";
      else if (selectedReportType == 2) oilType = "hydraulic";
      else if (selectedReportType == 3) oilType = "maintenance";

      dispatch(fetchMachineListForBulkUpload(selectedCompany, oilType));
    } else {
      setSelectedMachine([]);
      setMachineList([]);
    }
  }, [selectedCompany, selectedReportType, dispatch]);

  useEffect(() => {
    setMachineList(machineListData);
    setSelectedMachine([]);
  }, [machineListData]);

  useEffect(() => {
    console.log("machineListData:", JSON.stringify(machineListData));
    console.log("machineList:", JSON.stringify(machineList));
  }, [machineListData]);

  useEffect(() => {
    if (selectedReportType == 2) {
      dispatch(fetchOilList({ selectedOil: "coolant" }));
    }
  }, [selectedReportType]);

  // Update filtered machine list based on search input
  useEffect(() => {
    setFilteredMachineList(
      machineList.filter((machine) =>
        machine?.name?.toLowerCase().includes(machineSearch.toLowerCase())
      )
    );
  }, [machineSearch, machineList]);

  const handleMachineSelection = (e) => {
    const selectedValue = e.target.value;
    let updatedSelectedMachines;

    if (selectedMachine.includes(selectedValue)) {
      updatedSelectedMachines = selectedMachine.filter(
        (machine) => machine !== selectedValue
      );
    } else {
      updatedSelectedMachines = [...selectedMachine, selectedValue];
    }

    setSelectedMachine(updatedSelectedMachines);

    // Check if all machines are selected
    setIsAllMachineSelect(
      updatedSelectedMachines.length === machineList.length
    );
  };

  const toggleSelectAll = () => {
    if (isAllMachineSelect) {
      setSelectedMachine([]); // Deselect all
    } else {
      setSelectedMachine(machineList.map((machine) => machine.serial_number)); // Select all
    }
    setIsAllMachineSelect(!isAllMachineSelect);
  };

  const handleGenerateReport = () => {
    if (!selectedCompany) {
      toast.error("Company not selected");
      return;
    }

    if (!selectedMachine) {
      toast.error("At least select one machine");
      return;
    }
    if (!startDate || !endDate) {
      toast.error("Date range not selected");
      return;
    }
    if (!selectedReportType) {
      toast.error("Report type not selected");
      return;
    }

    setIsLoader(true);

    const baseData = {
      company_id: parseInt(selectedCompany, 10),
      machine_id: selectedMachine,
      start_date: convertDateString(startDate),
      end_date: convertDateString(endDate),
      report_type: parseInt(selectedReportType, 10),
    };

    let data;

    switch (selectedReportType) {
      case "1":
        data = {
          ...baseData,
        };
        break;
      case "2":
        data = {
          ...baseData,
          oil_type: "hydraulic",
        };
        break;
      case "3":
        data = {
          ...baseData,
          oil_type: "maintenance",
        };
        break;
      default:
        toast.error("Invalid report type selected");
        setIsLoader(false);
        return;
    }
    dispatch(generateReport(data, setIsLoader));
  };

  // Handle 'Select All' and 'Deselect All'
  const handleAllMachineSelection = () => {
    if (isAllMachineSelect) {
      setSelectedMachine([]); // Deselect all machines
    } else {
      setSelectedMachine(machineList.map((machine) => machine.serial_number)); // Select all machines
    }
    setIsAllMachineSelect((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useClickOutside(
    [dropdownRef, anotherRef],
    () => setDropdownVisible(false),
    dropdownVisible
  );

  return (
    <>
      {isLoader ? (
        <Loader />
      ) : (
        <Container
          fluid
          className="d-flex align-items-center justify-content-center mt-4"
        >
          <Form>
            <h6 className="heading-small text-muted mb-4">Filter</h6>
            <div className="pl-lg-4">
              <Row>
                <Col lg="6">
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="selectCompany"
                    >
                      Select Company*
                    </label>
                    <Input
                      className="form-control-alternative"
                      type="select"
                      name="selectCompany"
                      id="selectCompany"
                      value={selectedCompany}
                      onChange={(e) => {
                        setSelectedCompany(e.target.value);
                        setSelectedMachine([]);
                        setIsAllMachineSelect(false);
                      }}
                    >
                      <option value="">Select Company</option>
                      {companyList.map((company) => (
                        <option key={company?.id} value={company?.id}>
                          {company?.company_name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>

                <Col lg="6">
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="input-last-name"
                    >
                      Select Report Type*
                    </label>
                    <Input
                      type="select"
                      name="selectReportType"
                      id="selectReportType"
                      value={selectedReportType}
                      onChange={(e) =>
                        setSelectedReportType(e.target.value)
                      }
                      className="admin-panel-select"
                    >
                      <option value="">Select Report Type</option>
                      {reportTypes.map((type) => (
                        <option key={type.id} value={type?.id}>
                          {type.name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="selectMachine"
                    >
                      Select Machine {selectedMachine.length > 0 && `(${selectedMachine.length} Selected)`}*
                    </label>
                    <div
                      onClick={toggleDropdown}
                      style={{
                        cursor: "pointer",
                        border: "1px solid #ced4da",
                        padding: "10px",
                        borderRadius: "4px",
                        position: "relative",
                        backgroundColor: "white",
                      }}
                      ref={anotherRef}
                    >
                      <div className="d-flex justify-content-between">
                        <span style={{ color: "#8898AA" }}>
                          {selectedMachine.length > 0
                            ? selectedMachine.length +
                            " Machine(s) Selected"
                            : "Select Machine(s)"}
                        </span>
                        <span>
                          <i
                            className={`fa-solid fa-caret-${dropdownVisible ? "up" : "down"
                              }`}
                          ></i>
                        </span>
                      </div>
                    </div>

                    {dropdownVisible && (
                      <div
                        style={{
                          maxHeight: "400px",
                          overflowY: "auto",
                          border: "1px solid #ced4da",
                          padding: "10px",
                          borderRadius: "4px",
                          position: "absolute",
                          zIndex: 1000,
                          width: "93%",
                          backgroundColor: "white",
                        }}
                        ref={dropdownRef}
                      >
                        {/* Search Input */}
                        <Input
                          className="mb-2"
                          placeholder="Search Machine by Name"
                          type="text"
                          value={machineSearch}
                          onChange={(e) =>
                            setMachineSearch(e.target.value)
                          }
                        />

                        {filteredMachineList.length === 0 ? (
                          <div>No machines found</div>
                        ) : (
                          <>
                            {/* Select All Checkbox */}
                            <CustomInput
                              type="checkbox"
                              id="selectAll"
                              label={`Select All (${filteredMachineList.length})`}
                              checked={isAllMachineSelect}
                              onChange={toggleSelectAll}
                              className="m-1"
                            />
                            {filteredMachineList.map((machine) => (
                              <CustomInput
                                key={machine.serial_number}
                                type="checkbox"
                                id={machine.serial_number}
                                label={`${machine.name} (${machine.serial_number})`}
                                value={machine.serial_number}
                                checked={selectedMachine.includes(
                                  machine.serial_number
                                )}
                                onChange={handleMachineSelection}
                                className="m-1"
                              />
                            ))}
                          </>
                        )}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col lg="6">
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="input-first-name"
                    >
                      Select Date Range*
                    </label>
                    <DatePicker
                      selected={startDate}
                      onChange={(update) => setDateRange(update)}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      dateFormat="dd/MM/yyyy"
                      className="form-control admin-panel-datepicker"
                      placeholderText="Select Date Range"
                      isClearable
                      maxDate={new Date()}
                      wrapperClassName="w-100"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <hr className="my-4" />
            <div className="pl-lg-4">
              <Row>
                <Col md="12" className="text-center">
                  <Button
                    style={{ background: "rgb(14, 61, 13)" }}
                    onClick={handleGenerateReport}
                    disabled={
                      !selectedCompany ||
                      !selectedMachine ||
                      !startDate ||
                      !endDate ||
                      !selectedReportType
                    }
                  >
                    {" "}
                    <i class="fa-solid fa-cloud-arrow-down mr-1"></i>{" "}
                    Download
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Container>
      )}
    </>
  );
};

export default Report;
